/**
 * Limits for a From and To pair of date boxes (discounts review, 2026-09-29:
 * "suggest you not allow to select the future date").
 *
 * A report about days that have not happened is empty, and an empty report
 * reads as broken; a From after its To is the same mistake. The boxes refuse
 * both instead of answering them with nothing (§2.2-7, prevent the error).
 *
 * "Today" is the till's own date — the till is in the shop, so its clock is
 * the shop's.
 */
export function isoDay(at: Date): string {
  const month = String(at.getMonth() + 1).padStart(2, '0');
  const day = String(at.getDate()).padStart(2, '0');
  return `${at.getFullYear()}-${month}-${day}`;
}

export function dateRangeLimits(
  from: string | null,
  to: string | null,
  today: string = isoDay(new Date()),
): { from: { max: string }; to: { min?: string; max: string } } {
  const before = (a: string, b: string) => (a < b ? a : b);
  return {
    from: { max: to !== null && to !== '' ? before(to, today) : today },
    to: { ...(from !== null && from !== '' ? { min: from } : {}), max: today },
  };
}
